import { NavLink } from "react-router";

import { cn } from "@punto-firma/ui/lib/utils";

export interface TabNavItem {
  label: string;
  to: string;
  /** Activa solo con la ruta exacta (p. ej. Usuarios en `/people`). */
  end?: boolean;
}

/**
 * Pestañas que son rutas (detalle de certificado, Personas, Actividad,
 * Plataforma): cada pestaña es una URL, así se puede enlazar y volver atrás. Para
 * pestañas sin URL está `Tabs` de `@punto-firma/ui/components/tabs`.
 */
export const TabNav = ({
  items,
  label,
  className,
}: {
  items: TabNavItem[];
  label: string;
  className?: string;
}) => (
  <nav aria-label={label} className={cn("border-b", className)}>
    <ul className="-mb-px flex gap-6 overflow-x-auto">
      {items.map((item) => (
        <li key={item.to}>
          <NavLink
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              cn(
                "inline-flex h-10 items-center whitespace-nowrap border-b-2 text-sm transition-colors",
                isActive
                  ? "border-foreground font-medium text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )
            }
          >
            {item.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
